import { EmptyStateSize } from '../contexts/size';

export const getButtonSize = (size: EmptyStateSize) => {
  switch (size) {
    case EmptyStateSize.smallMenu:
      return 'small';
    case EmptyStateSize.largeSurface:
    case EmptyStateSize.mediumSurface:
    case EmptyStateSize.mediumMenu:
    default:
      return 'medium';
  }
};
